import React, {useEffect, useState, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import instagramContentIcon from "../icons/instagram-content.svg"; // Replace with path to your Google icon
import facebookContentIcon from "../icons/facebook-content.svg"; // Replace with path to your Google icon
import linkedInContentIcon from "../icons/linkedin-content.svg"; // Replace with path to your Google icon
import emptyContentPlanIcon from "../icons/empty-content-plan.svg"; // Replace with path to your Google icon
import DropdownContent from "./DropdownContent";
import {contentPlanActions} from "../../store";
import ContentPlanDrawer from "./ContentPlanDrawer";
// import { forwardRef } from 'react';
import {useTranslation} from "react-i18next";
import moment from "moment";
import {useNavigate} from "react-router-dom";
import {message, notification,} from "antd";
import {jwtDecode} from "jwt-decode";
import {fetchWrapper} from "../../helpers";
import {daysOfWeek} from "../../constants/daysOfWeek";
import weekday from "dayjs/plugin/weekday";
import AppNavigation from "../../components/AppNavigation";
// Ant Design
import {
    Layout,
    Row,
    Col,
    Card,
    Typography,
    Divider,
    Space,
    Button,
    Checkbox,
    Spin,
    Badge,
    Tooltip,
    Tabs,
    Progress,
    Avatar,
    Tag,
} from "antd";

// Ant Design Icons
import {
    SendOutlined,
    PlusOutlined,
    ArrowLeftOutlined,
    ArrowRightOutlined,
    ThunderboltOutlined,
    EyeOutlined,
    CalendarOutlined,
    LinkedinOutlined,
    InstagramOutlined,
    FacebookOutlined,
} from "@ant-design/icons";
import {ImeanHeader} from "../../components/Header/Header";

const icons = [instagramContentIcon, facebookContentIcon, linkedInContentIcon];
const colors = ["#000", "#000", "#000"];
const baseUrl = `${process.env.REACT_APP_API_URL}`;
const generateLangs = [
    {
        id: 1,
        label: {
            ru: "на русском языке",
            en: "in russian language",
        },
        value: "на русском языке",
    },
    {
        id: 2,
        label: {
            ru: "на английском языке",
            en: "in english language"
        },
        value: "in english language",
    }
];


export const CreateContentPlan = () => {
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {
        socialNetworks,
        contentPlans,
        weeks,
        loading,
        generating,
        loadingCreate,
    } = useSelector((obj) => obj.contentPlan);
    const [fbPageId, setFbPageId] = useState('');
    const [isToLate, setIsToLate] = useState(false);
    const [activeWeek, setActiveWeek] = useState(+sessionStorage.getItem('activeWeek') || weeks[0]);
    const [hasContentPlanForWeek, setHasContentPlanForWeek] = useState();
    const [currentWeekSnCreated, setCurrentWeekSnCreated] = useState({});
    const [selectedGeneratingWeekDays, setSelectedGeneratingWeekDays] = useState(daysOfWeek);
    const [activeContentPlans, setActiveContentPlans] = useState({});
    const [visibleOpenModal, setVisibleModal] = useState(false);
    const interval = useRef(null);
    const [notificationApi, notificationContextHolder] =
        notification.useNotification();
    const user = useSelector((obj) => obj.auth.user);
    const [token, setToken] = useState(false);
    const blocks = useSelector((obj) => obj.strategy.blocks);
    const [localUser, setLocalUser] = useState(
        JSON.parse(localStorage.getItem("user"))
    );
    const [generateLang, setGenerateLang] = useState(i18n.language === 'ru' ? generateLangs[0].value : generateLangs[1].value);
    const [sn, setSn] = useState('');
    const [tokens, setTokens] = useState({
        instagram: false,
        facebook: false,
        linkedin: false
    });

    const openNotification = () => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button
                    type="primary"
                    size="small"
                    onClick={() => navigate("/support")}
                >
                    {t("posts.goToSupport")}
                </Button>
            </Space>
        );
        notificationApi.open({
            message: t("functions.error"),
            description: t("posts.unknownError"),
            btn,
            key,
        });
    };

    const openNotificationEndSubscribe = () => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button
                    type="primary"
                    size="small"
                    onClick={() => navigate("/subscription-plans")}
                >
                    {t("posts.goToRate")}
                </Button>
            </Space>
        );
        notificationApi.open({
            message: t("functions.error"),
            description: t("posts.limit"),
            btn,
            key,
        });
    };

    const openNotificationSocialNetwork = ({message, description}) => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button
                    type="primary"
                    size="small"
                    onClick={() => navigate("/profile")}
                >
                    {t("posts.goToProfile")}
                </Button>
            </Space>
        );
        notificationApi.open({
            message: message || t("functions.error"),
            description: description || t("posts.unknownError"),
            btn,
            key,
        });
    };

    const generateContentPlan = async (values) => {
        message.loading(t("functions.generating"));
        await Promise.all(
            values.socialNetworks.map(async (sn) =>
                dispatch(
                    contentPlanActions.createContentPlan({
                        socialNetwork: sn,
                        content_blocks: values.contentBlocks,
                        frequency: values.frequency,
                        timezone: -new Date().getTimezoneOffset(),
                        lang: generateLang,
                        week: activeWeek,
                        days: selectedGeneratingWeekDays,
                        openNotificationEndSubscribe,
                        openNotification,
                    })
                )
            )
        )
            .then(() => {
                message.success(t("functions.successfullySendToGenerate"));
            })
            .catch((error) => {
                // console.log(error);
                // if (error === 'Достигнут лимит действий'){
                //   openNotificationEndSubscribe();
                // } else {
                //   openNotification();
                // }
                message.error(t("functions.wrong"));
            });
        setVisibleModal(false);
    };

    const openNotificationLinkedIn = () => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button type="primary" size="small" onClick={() => navigate("/profile")}>
                    {t("profile.linkAccount")}
                </Button>
            </Space>
        );
        notificationApi.open({
            message: t("contentPlan.tokenError"),
            btn,
            key,
        });
    };

    const handleGenerateContentPlan = () => {
        if (!token) {
            openNotificationLinkedIn()
        } else {
            generateContentPlan({
                contentBlocks: blocks,
                socialNetworks: sn.split(','),
                frequency: 7,
            })
        }
    }

    useEffect(() => {
        setActiveWeek(+sessionStorage.getItem('activeWeek') || weeks.length);
    }, [weeks]);

    useEffect(() => {
        if (generating) {
            interval.current = setInterval(() => {
                dispatch(contentPlanActions.getContentPlan(socialNetworks));
            }, 5000);
        } else {
            clearInterval(interval.current);
            interval.current = null;
        }

        return () => {
            clearInterval(interval.current);
        };
    }, [dispatch, generating, interval]);

    const handleChangeSocialNetworks = (value) => {
        if (!tokens[value.toLowerCase()]) {
            return openNotificationSocialNetwork({
                message: t("functions.error"),
                description: t(`posts.notLinked-${value.toLowerCase()}`),
            });
        }
        setSn((prevState) => {
            if (prevState.includes(value)) {
                return prevState.split(',').filter(item => item !== value).join(',')
            } else {
                if (prevState === '') {
                    return value
                } else {
                    return `${prevState},${value}`
                }
            }
        });
    }

    // useEffect(() => {
    //   if (socket) {
    //     socket.on('finishedContentPlan', () => {
    //       dispatch(contentPlanActions.getContentPlan(socialNetworks))
    //     })
    //   }

    // }, [socket])

    useEffect(() => {
        dispatch(contentPlanActions.getContentPlan(socialNetworks));
    }, []);

    useEffect(() => {
        let lastDate = '';
        const freshCurrentWeekSnCreated = {};
        let tempHasCn = false;
        const tempCn = {};

        for (const sn of socialNetworks) {
            const filteredCn = contentPlans[sn.fetch].filter(
                (cn) => cn.week == activeWeek
            );

            if (filteredCn.length) {
                freshCurrentWeekSnCreated[sn.generate] = true;
            } else {
                freshCurrentWeekSnCreated[sn.generate] = false;
            }

            if (filteredCn.length > 0) {
                tempHasCn = true;
            }
            tempCn[sn.fetch] = filteredCn;

            if (!lastDate || filteredCn[filteredCn.length - 1]?.date < lastDate) {
                lastDate = filteredCn[filteredCn.length - 1]?.date;
            }
        }

        if (new Date(lastDate) < new Date()) {
            setIsToLate(true);
        } else {
            setIsToLate(false);
        }

        setCurrentWeekSnCreated(freshCurrentWeekSnCreated);
        setHasContentPlanForWeek(tempHasCn);
        setActiveContentPlans(tempCn);
    }, [activeWeek, contentPlans, loading, socialNetworks]);

    useEffect(() => {
        fetchWrapper
            .get(`${baseUrl}/auth/getSocialMediaTokens/`)
            .then((res) => {
                let filteredSn = [];
                const filteredToken = {
                    facebook: false,
                    instagram: false,
                    linkedin: false,
                };
                res.forEach((token) => {
                    if (token.socialMediaType === "FACEBOOK") {
                        filteredToken.facebook = true;
                        if (!currentWeekSnCreated.facebook) {
                            filteredSn.push('Facebook')
                        }
                        setToken(true)
                    }
                    if (token.socialMediaType === "INSTAGRAM") {
                        filteredToken.instagram = true;
                        if (!currentWeekSnCreated.instagram) {
                            filteredSn.push('Instagram')
                        }
                        setToken(true)
                    }
                    if (token.socialMediaType === "LINKEDIN") {
                        filteredToken.linkedin = true;
                        if (!currentWeekSnCreated.linkedin) {
                            filteredSn.push('LinkedIn')
                        }
                        setToken(true)
                    }
                });
                setTokens(prevState => filteredToken);
                setSn(filteredSn.join(','));
            })
            .catch(() => {
            });
    }, [currentWeekSnCreated]);

    useEffect(() => {
        fetchWrapper.get(`${baseUrl}/profile/`).then((res) => {
            setFbPageId(res.facebookPageId);
        });
    }, []);

    const isEmpty = !loading && !hasContentPlanForWeek;

    return (
        <Layout style={{minHeight: "100vh", background: "linear-gradient(180deg, #ffffff 0%, #faf5ff 100%)"}}>
            {notificationContextHolder}

            {/* TOP BAR */}
            <ImeanHeader initialDark={true}></ImeanHeader>
            <Layout.Header
                style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 20,
                    background: "rgba(255,255,255,0.85)",
                    backdropFilter: "blur(6px)",
                    borderBottom: "1px solid #f0f0f0",
                    paddingInline: 16,
                }}
            >
                <Row align="middle" justify="space-between" style={{maxWidth: 1200, margin: "0 auto", width: "100%"}}>
                    <Space align="center" size={12}>
                        <Button type="text" onClick={() => {
                            sessionStorage.removeItem("activeWeek");
                            navigate("/home");
                        }}>
                            {t("common.back")}
                        </Button>
                        <Badge color="#7c3aed"/>
                        <Typography.Title level={4} style={{margin: 0}}>
                            {t("contentPlan.header")}
                        </Typography.Title>
                    </Space>

                    <Space>
                        <Button type='primary' onClick={() => setVisibleModal(true)} icon={<PlusOutlined/>}>
                            {t("contentPlan.create")}
                        </Button>
                    </Space>
                </Row>
            </Layout.Header>

            {/* CONTENT */}
            <Layout.Content style={{maxWidth: 1200, margin: "24px auto", width: "100%", padding: "0 16px"}}>
                {generating ? (
                    <Card
                        bordered
                        className="shadow-sm"
                        bodyStyle={{
                            padding: 24,
                            minHeight: "40vh",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <Typography.Title level={4} style={{marginBottom: 16}}>
                            {t("functions.generatingContentPlan")}
                        </Typography.Title>
                        <Spin size="large"/>
                    </Card>
                ) : (
                    <Row gutter={[16, 16]}>
                        {/* LEFT COLUMN */}
                        <Col xs={24} lg={14}>
                            {/* Week header */}
                            <Card bordered className="shadow-sm" bodyStyle={{padding: 16}}>
                                <Row align="middle" justify="space-between">
                                    <Space align="center" size={10}>
                                        <CalendarOutlined/>
                                        <Typography.Title level={5} style={{margin: 0}}>
                                            {t("contentPlan.week")} {activeWeek}{" "}
                                            {(
                                                activeContentPlans[socialNetworks[0]?.fetch]?.length > 0 ||
                                                activeContentPlans[socialNetworks[1]?.fetch]?.length > 0 ||
                                                activeContentPlans[socialNetworks[2]?.fetch]?.length > 0
                                            ) ? (
                                                <>
                                                    {" ("}
                                                    {moment(
                                                        activeContentPlans[socialNetworks[0]?.fetch]?.[0]?.date ||
                                                        activeContentPlans[socialNetworks[1]?.fetch]?.[0]?.date ||
                                                        activeContentPlans[socialNetworks[2]?.fetch]?.[0]?.date
                                                    ).format("DD/MM/YYYY")}
                                                    {" - "}
                                                    {moment(
                                                        activeContentPlans[socialNetworks[0]?.fetch]?.[
                                                        activeContentPlans[socialNetworks[0]?.fetch]?.length - 1
                                                            ]?.date ||
                                                        activeContentPlans[socialNetworks[1]?.fetch]?.[
                                                        activeContentPlans[socialNetworks[1]?.fetch]?.length - 1
                                                            ]?.date ||
                                                        activeContentPlans[socialNetworks[2]?.fetch]?.[
                                                        activeContentPlans[socialNetworks[2]?.fetch]?.length - 1
                                                            ]?.date
                                                    ).format("DD/MM/YYYY")}
                                                    {")"}
                                                </>
                                            ) : null}
                                        </Typography.Title>
                                    </Space>

                                    <Space split={<Divider type="vertical"/>} style={{color: "#8c8c8c"}}>
                                        <Space><InstagramOutlined/>Instagram</Space>
                                        <Space><LinkedinOutlined/>LinkedIn</Space>
                                        <Space
                                            className={`${process.env.REACT_APP_IS_HIDE_FACEBOOK === 'true' ? 'hidden' : ''}`}>
                                            <FacebookOutlined/>Facebook
                                        </Space>
                                    </Space>
                                </Row>
                            </Card>

                            {/* Gate: survey requirements */}
                            {localUser.strategiesCount < 5 ? (
                                <Card className="shadow-sm" style={{marginTop: 16}}
                                      bodyStyle={{padding: 24, textAlign: "center"}}>
                                    <Typography.Title level={5} style={{marginBottom: 8}}>
                                        {t("contentPlan.needSurveyText")}
                                    </Typography.Title>
                                    <Button type="primary" onClick={() => navigate("/survey")}>
                                        {t("contentPlan.goToSurveyBtnText")}
                                    </Button>
                                </Card>
                            ) : activeWeek === 3 && localUser.strategiesCount < 15 ? (
                                <Card className="shadow-sm" style={{marginTop: 16}}
                                      bodyStyle={{padding: 24, textAlign: "center"}}>
                                    <Typography.Title level={5} style={{marginBottom: 8}}>
                                        {t("contentPlan.needSurveyText")}
                                    </Typography.Title>
                                    <Button type="primary" onClick={() => navigate("/personality-survey")}>
                                        {t("contentPlan.goToSurveyBtnText")}
                                    </Button>
                                </Card>
                            ) : isEmpty ? (
                                <>
                                    {/* Social selection + weekdays (EMPTY STATE) */}
                                    <Card className="shadow-sm" style={{marginTop: 16}} bodyStyle={{padding: 16}}>
                                        <Row justify="space-between" align="middle">
                                            <Typography.Title level={5} style={{margin: 0}}>
                                                {t("contentPlan.selectNetworks")}
                                            </Typography.Title>
                                        </Row>
                                        <Divider style={{margin: "12px 0"}}/>
                                        <Row gutter={[12, 12]}>
                                            <Col span={8}>
                                                <Card
                                                    hoverable
                                                    onClick={() => handleChangeSocialNetworks("LinkedIn")}
                                                    bodyStyle={{
                                                        padding: 12,
                                                        textAlign: "center",
                                                        opacity: sn?.includes("LinkedIn") ? 1 : 0.4
                                                    }}
                                                >
                                                    <LinkedinOutlined/>
                                                    <div style={{marginTop: 8}}>LinkedIn</div>
                                                </Card>
                                            </Col>
                                            <Col span={8}
                                                 className={`${process.env.REACT_APP_IS_HIDE_FACEBOOK === 'true' ? 'hidden' : ''}`}>
                                                <Card
                                                    hoverable
                                                    onClick={() => handleChangeSocialNetworks("Facebook")}
                                                    bodyStyle={{
                                                        padding: 12,
                                                        textAlign: "center",
                                                        opacity: sn?.includes("Facebook") ? 1 : 0.4
                                                    }}
                                                >
                                                    <FacebookOutlined/>
                                                    <div style={{marginTop: 8}}>Facebook</div>
                                                </Card>
                                            </Col>
                                            <Col span={8}>
                                                <Card
                                                    hoverable
                                                    onClick={() => handleChangeSocialNetworks("Instagram")}
                                                    bodyStyle={{
                                                        padding: 12,
                                                        textAlign: "center",
                                                        opacity: sn?.includes("Instagram") ? 1 : 0.4
                                                    }}
                                                >
                                                    <InstagramOutlined/>
                                                    <div style={{marginTop: 8}}>Instagram</div>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Card>

                                    <Card className="shadow-sm" style={{marginTop: 16}} bodyStyle={{padding: 16}}>
                                        <Typography.Title level={5} style={{margin: 0, marginBottom: 8}}>
                                            {t("contentPlan.selectWeekDaysTitle")}
                                        </Typography.Title>
                                        <Divider style={{margin: "12px 0"}}/>
                                        <Space direction="vertical" style={{width: "100%"}}>
                                            {daysOfWeek.map((day) => (
                                                <Checkbox
                                                    key={day}
                                                    checked={selectedGeneratingWeekDays.includes(day)}
                                                    onChange={(e) => {
                                                        setSelectedGeneratingWeekDays(
                                                            e.target.checked
                                                                ? [...selectedGeneratingWeekDays, day]
                                                                : selectedGeneratingWeekDays.filter((d) => d !== day)
                                                        );
                                                    }}
                                                >
                                                    {t(`weekDays.${day}`)}
                                                </Checkbox>
                                            ))}
                                        </Space>

                                        {/* Hidden language select preserved */}
                                        <select
                                            className="border rounded-lg p-2.5 mt-2.5 text-center no-arrows cursor-pointer hidden"
                                            value={generateLang}
                                            onChange={(e) => setGenerateLang(e.target.value)}
                                        >
                                            {generateLangs.map((lng) => (
                                                <option key={lng.id} value={lng.value}>
                                                    {lng.label[i18n.language]}
                                                </option>
                                            ))}
                                        </select>

                                        <Row justify="end" style={{marginTop: 16}}>
                                            <Button
                                                type="primary"
                                                icon={<ThunderboltOutlined/>}
                                                disabled={!sn || !selectedGeneratingWeekDays.length}
                                                onClick={handleGenerateContentPlan}
                                            >
                                                {t("contentPlan.create")}
                                            </Button>
                                        </Row>
                                    </Card>

                                    <div style={{display: "flex", justifyContent: "center", marginTop: 16}}>
                                        <img src={emptyContentPlanIcon} alt="Empty content plan"/>
                                    </div>
                                </>
                            ) : (
                                // Plans exist: show dropdown sections
                                <>
                                    {socialNetworks?.map((socialsNetwork, index) => (
                                        <Card key={socialsNetwork.fetch} className="shadow-sm" style={{marginTop: 16}}
                                              bodyStyle={{padding: 16}}>
                                            <DropdownContent
                                                color={colors[index]}
                                                icon={icons[index]}
                                                items={activeContentPlans[socialsNetwork?.fetch]}
                                                fbPageId={fbPageId}
                                                snTokens={tokens}
                                            />
                                        </Card>
                                    ))}
                                </>
                            )}
                        </Col>

                        {/* RIGHT COLUMN */}
                        <Col xs={24} lg={10}>
                            {/* Live Preview & Navigation between weeks */}
                            <Card className="shadow-sm" bodyStyle={{padding: 16}}>
                                <Row align="middle" justify="space-between">
                                    <Space align="center" size={8}>
                                        <EyeOutlined/>
                                        <Typography.Title level={5} style={{margin: 0}}>
                                            {t("contentPlan.week")}
                                        </Typography.Title>
                                    </Space>
                                    <Space>
                                        <Tooltip title={t("functions.previous")}>
                                            <Button
                                                onClick={() => {
                                                    if (activeWeek > 1) {
                                                        sessionStorage.setItem("activeWeek", activeWeek - 1);
                                                        setActiveWeek(+activeWeek - 1);
                                                    }
                                                }}
                                                icon={<ArrowLeftOutlined/>}
                                            />
                                        </Tooltip>
                                        <Tooltip title={t("functions.next")}>
                                            <Button
                                                onClick={() => {
                                                    sessionStorage.setItem("activeWeek", activeWeek + 1);
                                                    setActiveWeek(+activeWeek + 1);
                                                }}
                                                icon={<ArrowRightOutlined/>}
                                            />
                                        </Tooltip>
                                    </Space>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                )}

                {/* Drawer for generation config */}
                <ContentPlanDrawer
                    loadingCreate={loadingCreate}
                    onOk={handleGenerateContentPlan}
                    open={visibleOpenModal}
                    close={() => setVisibleModal(false)}
                    activeWeek={activeWeek}
                    handleChangeSocialNetworks={handleChangeSocialNetworks}
                    socialNetworks={sn}
                    currentWeekSnCreated={currentWeekSnCreated}
                    selectedGeneratingWeekDays={selectedGeneratingWeekDays}
                    setSelectedGeneratingWeekDays={setSelectedGeneratingWeekDays}
                />
            </Layout.Content>

            {/* App bottom nav (mobile) */}
            <div style={{height: 70}}/>
            <AppNavigation/>
        </Layout>
    );
};
